<div class="consent-box-wrapper id-verbiage">
    <!-- Consent Box -->
    <!-- add class="accordion--collapsed" to collapse -->
    <!-- <div class="consent-box consent-box--accordion accordion accordion--collapsed"> -->
    <div class="consent-box consent-box--accordion accordion" [ngClass]="{'accordion--collapsed' : !isTCPAOpen }">
        <div class="consent-box__title accordion__name" (click)="toggleTCPA()">
            <span>TCPA</span>
            <div class="accordion__trigger"><i class="fa-light fa-angle-up"></i></div>
        </div>
        <div class="accordion__content">
            <div class="consent-box__content">
                <p>Do you consent to being contacted by a representative of Digital Globe Service, Inc.,
                    TelSat Online, Inc., and/or other service providers, by email and/or phone - Including your
                    wireless number if provided -
                    by automated technology? Consent is not required as a condition of any sale of goods or
                    services.</p>
                    <p>[Note: Please be sure to hear the customer clearly state that they
                    consent
                    before checking
                    this box.)</p>
            </div>
            <div class="consent-box__btns">
                <div class="switcher-btn-wrapper">
                    <!-- Switcher Btn -->
                    <div class="switcher-btn">
                        <div class="switcher-btn__content">
                            <label for="toggle1">
                                <input type="checkbox" id="toggle1" [checked]="dialpadService.tcpaEnable"
                                    (change)="dialpadService.toggleTCPA()">
                                <div class="toggle"></div>
                                <div class="names">
                                    <p>No</p>
                                    <p>Yes</p>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        @if(dialpadService.tcpaEnable){
        <div class="consent-box__input-field">
            <app-dial-screen [number]="dialpadService.tcpaNumber" (numberChange)="dialpadService.setTCPANumber($event)"
                (onRemove)="dialpadService.removeTCPANumber()"></app-dial-screen>
        </div>
        }
        </div>
    </div>

    <div class="consent-box consent-box--accordion accordion" [ngClass]="{'accordion--collapsed' : !openWrapText }">
        <div class="consent-box__title accordion__name" (click)="toggleText()">
            <span>Wrap up Text</span>
            <div class="accordion__trigger"><i class="fa-light fa-angle-up"></i></div>
        </div>
        <div class="accordion__content">
             <!-- TODO: will handle this from campaign settings wrapup_script after portmore launch -->
            @if(campaignService.campaignCode === 'K38'){
            <div class="consent-box__content">
              <p>Can I transfer you to our security specialist to discuss the Vivint Security promos?</p>
            </div>
            <div class="consent-box__btns">
                <div class="switcher-btn-wrapper">
                    <!-- Switcher Btn -->
                    <div class="switcher-btn">
                        <div class="switcher-btn__content">
                            <label for="toggle1">
                                <input type="checkbox" id="toggle1" [checked]="dialpadService.isVivintPitched"
                                    (change)="dialpadService.togglePitchedVivint()">
                                <div class="toggle"></div>
                                <div class="names">
                                    <p>No</p>
                                    <p>Yes</p>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        }
        @else {
            <div class="consent-box__content">
                
                <p>Do you consent to being contacted by a representative of Digital Globe Service, Inc.,
                    TelSat Online, Inc., and/or other service providers, by email and/or phone - Including your
                    wireless number if provided -
                    by automated technology? Consent is not required as a condition of any sale of goods or
                    services.</p>
                    <p>[Note: Please be sure to hear the customer clearly state that they
                    consent
                    before checking
                    this box.)</p> 
        </div> 
        }
        </div>
    </div>
</div>
